import { reduxForm } from 'redux-form';

import { PRODUCTION_REPORT_SETUP_CREATE_REPORT_TEMPLATE } from 'Common/FormEnum';

function CreateProductionReportTemplateForm({ children }) {
  return children;
}

const ConnectedComponent = reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true,
  form: PRODUCTION_REPORT_SETUP_CREATE_REPORT_TEMPLATE,
})(CreateProductionReportTemplateForm);

export { ConnectedComponent as CreateProductionReportTemplateForm };



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/createreporttemplate/components/CreateProductionReportTemplateForm.js